import { render, staticRenderFns } from "./AddedTypeMenu.vue?vue&type=template&id=c1f807e4&scoped=true&"
import script from "./AddedTypeMenu.vue?vue&type=script&lang=js&"
export * from "./AddedTypeMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f807e4",
  null
  
)

export default component.exports